import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=43f6a380&scoped=true&"
import script from "./PageLoading.vue?vue&type=script&lang=js&"
export * from "./PageLoading.vue?vue&type=script&lang=js&"
import style0 from "./PageLoading.vue?vue&type=style&index=0&id=43f6a380&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f6a380",
  null
  
)

export default component.exports